import { AlertTriangle } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { useState } from 'react';

export default function DeleteConfirmModal({ isOpen, onClose, onConfirm, projectName }) {
  const [confirmText, setConfirmText] = useState('');
  const [step, setStep] = useState(1);

  if (!isOpen) return null;

  const handleFirstConfirm = () => {
    setStep(2);
  };

  const handleFinalConfirm = () => {
    if (confirmText === projectName) {
      onConfirm();
      setStep(1);
      setConfirmText('');
    }
  };

  const handleClose = () => {
    setStep(1);
    setConfirmText('');
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80" onClick={handleClose}>
      <div className="bg-card border border-destructive/30 p-8 max-w-md w-full mx-4" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center gap-3 mb-6">
          <AlertTriangle className="w-8 h-8 text-destructive" />
          <h3 className="font-mono text-2xl font-semibold text-destructive">
            {step === 1 ? 'Delete Project?' : 'Final Confirmation'}
          </h3>
        </div>

        {step === 1 ? (
          <>
            <p className="text-foreground mb-6">
              Are you sure you want to delete <strong>{projectName}</strong>? This action cannot be undone.
            </p>
            <div className="flex gap-4">
              <Button
                variant="outline"
                onClick={handleClose}
                className="flex-1 rounded-none font-mono uppercase tracking-widest text-xs"
              >
                Cancel
              </Button>
              <Button
                onClick={handleFirstConfirm}
                className="flex-1 bg-destructive text-destructive-foreground hover:bg-destructive/90 rounded-none font-mono uppercase tracking-widest text-xs"
              >
                Delete
              </Button>
            </div>
          </>
        ) : (
          <>
            <p className="text-foreground mb-4">
              Type <strong className="text-destructive">{projectName}</strong> to confirm deletion:
            </p>
            <Input
              value={confirmText}
              onChange={(e) => setConfirmText(e.target.value)}
              placeholder="Type project name"
              className="mb-6 bg-background border-input rounded-none font-mono"
            />
            <div className="flex gap-4">
              <Button
                variant="outline"
                onClick={handleClose}
                className="flex-1 rounded-none font-mono uppercase tracking-widest text-xs"
              >
                Cancel
              </Button>
              <Button
                onClick={handleFinalConfirm}
                disabled={confirmText !== projectName}
                className="flex-1 bg-destructive text-destructive-foreground hover:bg-destructive/90 rounded-none font-mono uppercase tracking-widest text-xs disabled:opacity-50"
              >
                Confirm Delete
              </Button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
